import React, { Component, createRef, FC } from 'react'

import classNames from 'classnames'
import { isEqual, throttle } from 'lodash'

import classes from './Carousel.module.scss'

type ArrowType = {
  isLeft: boolean
  disabled: boolean
  white: boolean
  onClick: () => void
  customClasses?: string
  activeHoverClasses?: string
  customIcon?: JSX.Element
}
//TODO: Можно в будущем заменить на пропсы, если будет необходимость
const config = {
  magnet: {
    distance: 10,
  },
  throttle: 5,
}

type ElementPosition = {
  elem: {
    width: number
    height: number
  }
  xMin: number
  xMax: number
  yMin: number
  yMax: number
}

type MousePosition = {
  x: number
  y: number
}

type State = {
  posElement: ElementPosition
  trandform: string
  trandformX: number
  transformY: number
  isActive: boolean
}

export class CustomArrow extends Component<ArrowType, State> {
  elementMagnet = createRef<HTMLDivElement>()

  constructor(props: ArrowType) {
    super(props)
    this.state = {
      posElement: {} as ElementPosition,
      trandform: 'string',
      trandformX: 0,
      transformY: 0,
      isActive: false,
    }
  }

  componentDidMount(): void {
    window.addEventListener('mousemove', this.mouseFunction)
    window.addEventListener('resize', this.resizeFunction)

    // delay(() => {
    const posElement = this.getElementsPosition()
    this.setState({ posElement })
    // }, 1000)
  }

  componentDidUpdate(): void {
    const posElement = this.getElementsPosition()

    if (!isEqual(posElement, this.state.posElement)) {
      this.setState({ posElement })
    }
  }

  componentWillUnmount(): void {
    window.removeEventListener('mousemove', this.mouseFunction)
    window.removeEventListener('resize', this.resizeFunction)
  }

  resizeFunction = throttle(() => {
    const posElement = this.getElementsPosition()
    this.setState({ posElement })
  }, config.throttle)

  mouseFunction = throttle((e: MouseEvent) => {
    const posMouse = this.getMousePosition(e)

    this.magnetElement(posMouse)
  }, config.throttle)

  getElementsPosition(): ElementPosition {
    if (!this.elementMagnet.current) {
      return {} as ElementPosition
    }

    const rect = this.elementMagnet.current?.getBoundingClientRect()
    const x = window.pageXOffset || document.documentElement.scrollLeft
    const y = window.pageYOffset || document.documentElement.scrollTop

    return {
      elem: {
        width: rect.width,
        height: rect.height,
      },
      xMin: rect.left + x - config.magnet.distance,
      xMax: rect.left + x + rect.width + config.magnet.distance,
      yMin: rect.top + y - config.magnet.distance,
      yMax: rect.top + y + rect.height + config.magnet.distance,
    }
  }

  getMousePosition(e: MouseEvent): MousePosition {
    const mouseX = e.pageX
    const mouseY = e.pageY

    return {
      x: mouseX,
      y: mouseY,
    }
  }

  magnetElement(posMouse: MousePosition): void {
    const { posElement } = this.state

    const mouseElement = this.getPosition(posMouse)

    const isEnter = () => {
      return (
        posElement?.xMin < posMouse.x &&
        posElement?.xMax > posMouse.x &&
        posElement?.yMin < posMouse.y &&
        posElement?.yMax > posMouse.y
      )
    }

    this.defaultAction(isEnter() ? 'onEnter' : 'onLeave', mouseElement)
  }

  getPosition(posMouse: MousePosition): MousePosition {
    const { posElement } = this.state

    const x =
      posMouse.x -
      (posElement?.xMin + config.magnet.distance + posElement?.elem?.width / 2)
    const y =
      posMouse.y -
      (posElement?.yMin + config.magnet.distance + posElement?.elem?.height / 2)

    return {
      x,
      y,
    }
  }

  defaultAction(
    action: 'onEnter' | 'onLeave',
    mouseElement: MousePosition
  ): void {
    if (action === 'onEnter') {
      this.setState({
        trandformX: mouseElement.x,
        transformY: mouseElement.y,
        trandform: `translate3d(${mouseElement.x}px,${mouseElement.y}px, 0)`,
        isActive: true,
      })
    } else if (action === 'onLeave') {
      this.setState({
        trandformX: 0,
        transformY: 0,
        trandform: '',
        isActive: false,
      })
    }
  }

  render(): JSX.Element {
    const {
      isLeft,
      disabled,
      white,
      onClick,
      customClasses = '',
      activeHoverClasses = '',
      customIcon,
    } = this.props
    const cn = classNames([
      isLeft ? 'icon-arrow-left' : 'icon-arrow-right',
      classes.arrow,
    ])
    const containerClass = classNames(
      classes['arrow-container'],
      isLeft
        ? classes['arrow-container--left']
        : classes['arrow-container--right'],
      [
        {
          [classes.disabled]: disabled,
          [classes.white]: white,
          [classes['is-active']]: this.state.isActive,
          [customClasses]: customClasses,
          [activeHoverClasses]: activeHoverClasses && this.state.isActive,
        },
      ]
    )
    return (
      <div
        className={containerClass}
        ref={this.elementMagnet}
        onClick={() => onClick()}
      >
        <div className={classes.wrap}>
          {customIcon ? customIcon : <i aria-hidden="true" className={cn} />}
          <div
            className={classes.round}
            style={{ transform: this.state.trandform }}
          ></div>
        </div>
      </div>
    )
  }
}

export const DefaultArrow: FC<ArrowType> = ({ isLeft, white, onClick }) => {
  const cn = classNames([
    isLeft ? 'icon-arrow-left' : 'icon-arrow-right',
    classes.arrow,
  ])
  const containerClass = classNames(
    classes['arrow-container'],
    classes.no_magnet,
    isLeft
      ? classes['arrow-container--left']
      : classes['arrow-container--right'],
    [
      {
        [classes.white]: white,
      },
    ]
  )

  return (
    <div className={containerClass} onClick={() => onClick()}>
      <i aria-hidden="true" className={cn} />
    </div>
  )
}
